import React from "react";
import classNames from "classnames";
import styles from "./ActionButtonContainer.module.scss";

export default ({children, className}) => {
    return <div className={classNames(styles["action-button-container"], className)}>{children}</div>
};
